import { __decorate, __metadata } from "tslib";
import { appendClass, appendStyle, subscribe } from '@1inch-community/core/lit-utils';
import { css, html, LitElement } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { filter, fromEvent, tap } from 'rxjs';
let LoaderSkeletonMaskElement = class LoaderSkeletonMaskElement extends LitElement {
    constructor() {
        super(...arguments);
        this.animationDelayMillisecond = 0;
        this.animationEnabled = true;
        this.animationIntervalEnabled = true;
    }
    static { this.tagName = 'inch-loader-skeleton-mask'; }
    static { this.styles = css `
    :host {
      mask-image: linear-gradient(to right, black, black);
    }

    :host(.loader) {
      mask-image: linear-gradient(to right, black, transparent, black, black, black);
      mask-size: 200% 100%;
      mask-position: 100% 0;
      animation: pulse 2s linear infinite;
    }

    @keyframes pulse {
      0% {
        mask-position: 100% 0;
        -webkit-mask-position: 100% 0;
      }
      100% {
        mask-position: -100% 0;
        -webkit-mask-position: -100% 0;
      }
    }
  `; }
    set showLoader(state) {
        this.animationEnabled = state;
        if (state) {
            this.animationIntervalEnabled = true;
        }
    }
    firstUpdated() {
        subscribe(this, fromEvent(this, 'animationiteration').pipe(filter(() => !this.animationEnabled), tap(() => {
            this.animationIntervalEnabled = false;
        })));
    }
    render() {
        appendStyle(this, {
            animationDelay: `${this.animationDelayMillisecond}ms`,
        });
        appendClass(this, {
            loader: this.animationIntervalEnabled,
        });
        return html ` <slot></slot> `;
    }
};
__decorate([
    property({ type: Number, attribute: false }),
    __metadata("design:type", Number)
], LoaderSkeletonMaskElement.prototype, "animationDelayMillisecond", void 0);
__decorate([
    property({ type: Boolean, attribute: false }),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], LoaderSkeletonMaskElement.prototype, "showLoader", null);
__decorate([
    state(),
    __metadata("design:type", Object)
], LoaderSkeletonMaskElement.prototype, "animationEnabled", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], LoaderSkeletonMaskElement.prototype, "animationIntervalEnabled", void 0);
LoaderSkeletonMaskElement = __decorate([
    customElement(LoaderSkeletonMaskElement.tagName)
], LoaderSkeletonMaskElement);
export { LoaderSkeletonMaskElement };
//# sourceMappingURL=loader-skeleton-mask.element.js.map